(function () {
  'use strict';
  const elementName = 'anthology-birthstone-ring-size';
  if (customElements.get(elementName)) return;
  class BirthstoneRingSize extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.section = this.closest('.shopify-section');
      if (!this.section) return;
      this.error = this.querySelector('[data-ring-size-error]');
      this.fields = Array.from(this.querySelectorAll('input[name="properties[Ring Size]"]'));
      this.associate = () => {
        this.form = this.section.querySelector('form.js-product-form-main');
        const formId = this.form && this.form.getAttribute('id');
        if (!formId) return;
        this.querySelectorAll('input[name^="properties["]').forEach(field => {
          if (field.getAttribute('form') !== formId) field.setAttribute('form', formId);
        });
      };
      this.onSubmit = event => {
        this.associate();
        if (event.target !== this.form) return;
        const selected = !this.fields.length || this.fields.some(field => field.checked && !field.disabled);
        if (this.error) this.error.hidden = selected;
        const later = this.section.querySelector('#customize-later-property');
        const customizeLater = !!later && !later.disabled;
        const missing = [];
        ['name', 'date'].forEach(key => {
          const field = this.querySelector('[data-ring-' + key + ']');
          if (!field) return;
          const invalid = !customizeLater && (!field.value.trim() || field.value.length > field.maxLength);
          const error = this.querySelector('[data-ring-' + key + '-error]');
          if (error) error.hidden = !invalid;
          field.setAttribute('aria-invalid', String(invalid));
          if (invalid) missing.push(field);
        });
        if (selected && !missing.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const focus = selected ? missing[0] : this.fields[0];
        if (focus) focus.focus();
      };
      this.onChange = () => {
        if (this.error && this.fields.some(field => field.checked)) this.error.hidden = true;
      };
      document.addEventListener('submit', this.onSubmit, true);
      this.addEventListener('change', this.onChange);
      this.observer = new MutationObserver(this.associate);
      this.observer.observe(this.section, { childList: true, subtree: true });
      this.associate();
    }
    disconnectedCallback() {
      if (this.onSubmit) document.removeEventListener('submit', this.onSubmit, true);
      if (this.onChange) this.removeEventListener('change', this.onChange);
      if (this.observer) this.observer.disconnect();
      this.bound = false;
    }
  }
  customElements.define(elementName, BirthstoneRingSize);
})();
